export default "__VITE_ASSET__DP4lrKe4__"